import React from 'react';

// Styles & Assets
import styles from './Toolbar.module.css';
import { IoIosArrowBack } from 'react-icons/io';
import { IoIosMenu } from 'react-icons/io';

// Context
import GeneralContext from '../../../context/GeneralContext';

// Hooks
import { useContext } from 'react';

// Components
import NavbarWrapper from '../NavbarWrapper/NavbarWrapper';
import Icon from '../Icon/Icon';

// Language
import { useTranslation } from 'react-i18next';

// Other
import { Link } from 'react-router-dom';

const Toolbar: React.FC<{
    text?: string | null,
    link?: string,
    children?: React.ReactNode
}> = ({ text, link, children }) => {

    const { t } = useTranslation();

    const generalContext = useContext(GeneralContext);

    const handleChangeSidebarMode = () => generalContext.setOpenSidebar(prev => !prev);

    return (
        <NavbarWrapper>
            <div className={styles.toolbarContainer}>
                {!generalContext.openSidebar &&
                    <button onClick={handleChangeSidebarMode}>
                        <Icon><IoIosMenu /></Icon>
                    </button>
                }
                {link !== undefined && text !== undefined && text !== null &&
                    <Link to={link} className={styles.linkBack}>
                        <IoIosArrowBack />
                        <p>{t('back_to') + ' '}
                            <span className={styles.patientsUnderline}>
                                {text}
                            </span>
                        </p>
                    </Link>
                }
                {children &&
                    <div className={styles.toolbarChildren}>
                        {children}
                    </div>
                }
            </div>
        </NavbarWrapper>
    );
};

export default Toolbar;